import { Link } from "react-router-dom";
import AxiosClient from "../../assets/AxiosClient";
import { useEffect, useState } from "react";
import { useStateContext } from "../../Contexts/ContextProvider";

const SectionsRow = ({ id, title, description, artImage, status,  onDelete }) => {
  const {API} = useStateContext(); 
  const handleDeleteArt = () => {
    const confirmed = window.confirm("Are you sure you want to delete this Section?");

    if (confirmed) {
      onDelete(id);
    }
  };


  return (
    <>
      <tr>
        <td className="h1 text-dark">
          <div className=" px-2">
            <div></div>
            <div className="">
              <h6 className="mb-0 ">{title}</h6>
            </div>
          </div>
        </td>
       
   
        <td className="align-middle text-center">
          <div className="d-flex align-items-center justify-content-center">
            {description}
            <div></div>
          </div>
        </td>
        <td className="align-middle">
          <Link to={`./Edite/${id}`} className="btn btn-info m-2">Edit Section
          </Link>
            <button className="btn btn-danger  m-2" onClick={handleDeleteArt}>Delete Sections </button>
        </td>
      </tr>
    </>
  );
};

export default SectionsRow;